<template>
    <div id="wechat-auth"></div>
</template>

<script>
export default {
    name: "WechatAuth",
    beforeMount () {
        const query = this.$router.currentRoute.query
        if (query.isTui == 'true' && query.info) {
            this.$store.commit('SET_TUI_WECHAT_OPENID', query.info)
        } else if (query.openId) {
            this.$store.commit('SET_WECHAT_OPENID', query.openId)
        }
        if (query.returnUrl) {
            location.href = query.returnUrl
        } else {
            location.href = '/'
        }
    }
}
</script>

<style lang="less" scoped>
#wechat-auth {
    display: none;
}
</style>